export default __webpack_public_path__ + "static/media/1218.5cd3ce4d.png";